export default function headerCompact() {
  const header = document.querySelector('.gh-head');
  if (!header) return;

  let ticking = false;
  window.addEventListener('scroll', () => {
    if (!ticking) {
      requestAnimationFrame(() => {
        if (window.scrollY > 100) {
          header.classList.add('compact');
        } else if (window.scrollY < 50) {
          header.classList.remove('compact');
        }
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });
}
